import {AnimationControls} from "framer-motion";

export namespace FramerMotionUtil {

    export function shakeAnimation(controls: AnimationControls): void {
        controls.start({ x: [-10,0,10,0] }, { duration: 0.2, type: 'spring' });
    }
}
